import * as React from "react";
import { Edit, SimpleForm, SelectInput, TextInput, DateTimeInput, required, useDataProvider, BooleanInput } from "react-admin";
import { useClub } from "../club/ClubContext";
import { useNavigate } from "react-router-dom";
import { Box, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ROLE_LABELS } from "../dataProvider/resources/users";

export function UserEdit() {
  const dataProvider = useDataProvider();
  const { clubId } = useClub();
  const navigate = useNavigate();
  const [choices, setChoices] = React.useState<{ id: string; name: string }[]>([]);

  React.useEffect(() => {
    if (!clubId) return;
    (async () => {
      const res: any = await dataProvider.getList("assignableRoles", {
        pagination: { page: 1, perPage: 100 },
        sort: { field: "id", order: "ASC" },
        filter: { clubId },
      });
      setChoices(res.data);
    })().catch((e) => {
      console.error("roles load failed", e);
      setChoices([]);
    });
  }, [dataProvider, clubId]);

  // Add current role to choices if missing (e.g. same-level roles not assignable by self)
  const allRoleChoices = React.useMemo(() => {
    const ids = new Set(choices.map((c) => c.id));
    const extra = Object.entries(ROLE_LABELS)
      .filter(([id]) => !ids.has(id))
      .map(([id, name]) => ({ id, name }));
    return [...choices, ...extra];
  }, [choices]);

  return (
    <Box p={2}>
      <Box mb={2}>
        <Button startIcon={<ArrowBackIcon />} onClick={() => navigate("/users")}>
          Zurück zur Spielerliste
        </Button>
      </Box>

      <Edit
        transform={(data) => ({
          ...data,
          club_id: data.club_id ?? clubId,
        })}
      >
        <SimpleForm>
          <TextInput source="email" validate={[required()]} fullWidth />
          <TextInput source="first_name" fullWidth />
          <TextInput source="last_name" fullWidth />
          <TextInput source="clubs" sx={{ display: "none" }} />
          <BooleanInput source="is_active" label="Aktiv" />
          <TextInput source="club_id" sx={{ display: "none" }} defaultValue={clubId} />
          <SelectInput
            source="club_role"
            label="Gruppe"
            choices={choices}
            helperText="Nur Gruppen unterhalb der eigenen Rolle sind wählbar"
            fullWidth
            emptyText="– unverändert –"
            parse={(v: any) => v || null}
          />
          <DateTimeInput
            source="absence_start"
            label="Abwesend von"
            helperText="Termine und Job-Zuweisungen in diesem Zeitraum werden automatisch abgesagt."
          />
          <DateTimeInput source="absence_end" label="Abwesend bis" />
        </SimpleForm>
      </Edit>
    </Box>
  );
}
